import { ReactNode } from "react";
import {
  CommitIcon,
  ComponentBooleanIcon,
  ComponentInstanceIcon,
  ComponentNoneIcon,
  ComponentPlaceholderIcon,
  Half1Icon,
} from "@radix-ui/react-icons";

export const categories = [
  "bug",
  "feedback",
  "general_request",
  "feature_request",
  "information_or_education",
  "troubleshooting",
] as const;

export const categoryToLabel: Record<string, string> = {
  bug: "Bug",
  feedback: "Feedback",
  general_request: "Request",
  feature_request: "Feature Request",
  information_or_education: "Education",
  troubleshooting: "Troubleshooting",
  other: "Other",
};

export const categoryToIcon: Record<string, ReactNode> = {
  bug: <ComponentNoneIcon />,
  feedback: <ComponentBooleanIcon />,
  general_request: <ComponentInstanceIcon />,
  feature_request: <ComponentPlaceholderIcon />,
  information_or_education: <Half1Icon />,
  troubleshooting: <CommitIcon />,
};

export function CategoryFormatter({ value }: { value: string }) {
  return (
    <span className="flex items-center gap-1">
      <span className="flex-shrink-0">{categoryToIcon[value]}</span>
      <span className="truncate">{categoryToLabel[value] ?? value}</span>
    </span>
  );
}
